import INVENTORY_API_BASE_URL from "../../config/api";
import React, { useEffect, useState } from "react";
import axios from "axios";
import "./managementor.css";
import Table from "react-bootstrap/Table";

function Managementor() {
  const [mentors, setMentors] = useState([]);

  useEffect(() => {
    const fetchMentors = async () => {
      try {
        const response = await axios.get(
          `${INVENTORY_API_BASE_URL}/get-mentors`
        );
        setMentors(response.data);
      } catch (error) {
        console.error("Error fetching mentors:", error);
      }
    };

    fetchMentors();
  }, []);

  return (
    <div className="managementor-container">
      <h2 style={{ textAlign: "center" }}>All Mentors Data</h2>

      <div style={{ overflowX: "auto", width: "100%" }}>
        <table
          style={{
            width: "100%",
            minWidth: "1400px",
            borderCollapse: "collapse",
            textAlign: "center",
          }}
        >
          <thead>
            <tr>
              {[
                "Mentor Name",
                "Mobile",
                "Email",
                "Bank Holder",
                "Account Number",
                "IFSC",
                "PAN",
                "Aadhar",
                "See Aadhar",
                "Social Media",
                "Coupon",
                "See Cancelled Cheque",
              ].map((heading, index) => (
                <th key={index} style={headerStyle}>
                  {heading}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {mentors.map((mentor) => (
              <tr key={mentor._id}>
                <td style={cellStyle}>{mentor.mentorName}</td>
                <td style={cellStyle}>{mentor.mobileNumber}</td>
                <td style={cellStyle}>{mentor.email}</td>
                <td style={cellStyle}>{mentor.bankAccountHolderName}</td>
                <td style={cellStyle}>{mentor.bankAccountNumber}</td>
                <td style={cellStyle}>{mentor.ifscCode}</td>
                <td style={cellStyle}>{mentor.panNumber}</td>
                <td style={cellStyle}>{mentor.aadharCard}</td>
               <td style={cellStyle}>
        {mentor.Aadhar && (
          <a
            href={`https://d6awmbeulqwbq.cloudfront.net/${mentor.Aadhar}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Download Aadhar
          </a>
        )}
      </td>
                <td style={cellStyle}>{mentor.socialMediaDetails}</td>
                <td style={cellStyle}>{mentor.coupancode}</td>
        <td style={cellStyle}>
        {mentor.CancelledCheque && (
          <a
            href={`https://d6awmbeulqwbq.cloudfront.net/${mentor.CancelledCheque}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Download Cancelled Cheque
          </a>
        )}
      </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Managementor;

const cellStyle = {
  border: "1px solid #ccc",
  padding: "10px",
  whiteSpace: "nowrap",
  textAlign: "center",
};

const headerStyle = {
  ...cellStyle,
  backgroundColor: "#f5f5f5",
};
